import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import Card from "react-bootstrap/Card";
import axios from "axios";
import "./AppCategories.css";
import { AsideBox } from "./AsideBox";

const API_KEY = process.env.REACT_APP_API_URL

export function MainBoxes() {
  const navigate = useNavigate();
  const [groupedData, setGroupedData] = useState({});

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(`${API_KEY}/api/apps/`);
        const allApps = response.data.apps;
       
        const featuredApps = allApps.filter((app) => {
          return app.is_approved === true;
        });

        // Remove duplicate apps based on _id
        // const uniqueApps = Array.from(new Map(apps.map(app => [app._id, app])).values());

        const grouped = featuredApps.reduce((acc, app) => {
          const categoryName = (
            app.category_id?.name || "Uncategorized"
          ).trim();
          if (!acc[categoryName]) {
            acc[categoryName] = [];
          }
          acc[categoryName].push(app);
          return acc;
        }, {});

        setGroupedData(grouped);
      } catch (error) {
        // console.error("Error fetching data:", error.message);
      }
    };

    getData();
  }, []);

  return (
    <div className="app-category-wrapper">
      <div className="tags-area">
        <button className="tag-button">
          <i className="bi bi-calendar-check-fill pe-2"></i>Today
        </button>
        <button className="tag-button">
          <i className="bi bi-newspaper pe-2"></i>New
        </button>
        <button className="tag-button">
          <i className="bi bi-bookmark-fill pe-2"></i>Most Saved
        </button>
        <button className="tag-button">
          <i className="bi bi-check-circle-fill pe-2"></i>Most Used
        </button>
        <button className="tag-button">
          <i className="bi bi-browser-chrome pe-2"></i>Browser Ext.
        </button>
        <button className="tag-button">
          <i className="bi bi-google-play pe-2"></i>Apps
        </button>
        <button className="tag-button">
          <i className="bi bi-discord pe-2"></i>Discord
        </button>
        <button className="tag-button tag-social">
          <i className="bi bi-twitter pe-2"></i>@toolify
        </button>
      </div>

      
    <br />

      {Object.entries(groupedData).map(([category, apps]) => (
        <div key={category} style={{ marginBottom: "20px" }}>
          <div className="category-heading">{category}</div>

          {/* RANDOM BUTTONS */}
          <div
            className="random-buttons"
            style={{ marginTop: "10px", marginBottom: "20px" }}
          >
            <button
              className="random-btn"
              style={{ backgroundColor: "#7150E6", color: "white" }}
            >
              All
            </button>
            <button className="random-btn">Technology</button>
            <button className="random-btn">Creativity</button>
            <button className="random-btn">Productivity</button>
            <button className="random-btn">Automation</button>
          </div>
          {/* RANDOM BUTTONS */}

          {/* Show all cards in home page  */}
          <div className="app-cards-container">
            {apps.map((app) => (
              <div
                className="app-card"
                key={app._id}
                onClick={() => navigate(`/api/apps/${app._id}`)}
              >
                <div className="app-card-body">
                  <div className="app-card-header">
                    <img
                      src={`${API_KEY}/temp/${app.company_logo}`}
                      className="app-logo"
                      alt="Company Logo"
                    />
                    <div className="app-title">{app.name}</div>
                  </div>
                  <div className="app-description">
                    {app.description?.length > 40
                      ? app.description.slice(0, 40) + "..."
                      : app.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}


//  {Object.entries(groupedData).map(([category, apps]) => (
//       <div key={category} style={{ marginBottom: "20px" }}>
//         {/* <div className="category-heading">{category}</div> */}

//         <div className="app-cards-container">
//           {apps.slice(0, 10).map((app) => (
//             <div
//               className="app-card"
//               key={app._id}
//               onClick={() => navigate(`/api/apps/${app._id}`)}
//             >
//               <div className="app-card-body">
//                 <div className="app-card-header">
//                   <img
//                     src={`${API_KEY}/temp/${app.company_logo}`}
//                     className="app-logo"
//                     alt="Company Logo"
//                   />
//                   <div className="app-title">{app.name}</div>
//                 </div>
//                 <div className="app-description">
//                   {app.description?.length > 40
//                     ? app.description.slice(0, 40) + "..."
//                     : app.description}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     ))}